import React, { createContext, useContext } from 'react';
import type {
  ATColumnType,
  ATColumnConfigType,
  ATColumnsCtxType,
  ATContextProviderProps,
} from './types';

const ATColumnsContext = createContext<ATColumnsCtxType<any>>({
  columns: [],
  columnsConfig: {},
  setColumns: () => null,
  setColumnsConfig: () => null,
});

export const useATColumns = (): ATColumnsCtxType<any> => {
  const ctx = useContext(ATColumnsContext);
  if (ctx === null) {
    throw new Error('useATColumns must be used within a ATColumnsProvider');
  }
  return ctx;
};

export const ATColumnsContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  const [columns, setColumns] = React.useState<ATColumnType<any>[]>([]);
  const [columnsConfig, setColumnsConfig] = React.useState<
    ATColumnConfigType<any>
  >({});

  const value = React.useMemo(
    () => ({
      columns,
      setColumns,
      columnsConfig,
      setColumnsConfig,
    }),
    [columns, columnsConfig],
  );

  return (
    <ATColumnsContext.Provider value={value}>
      {children}
    </ATColumnsContext.Provider>
  );
};
